var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.getSelectedJournal.name)+" ")]),_c('v-card-text',[(_vm.getEditor)?_c('editor-content',{staticClass:"editor",attrs:{"editor":_vm.getEditor}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }